module.exports = __webpack_public_path__ + "img/4.05952b0a.jpg";